module.exports = __webpack_public_path__ + "media/comment_ca_marche/dessin-c7c0e3f2.png";